// ============================================================
// CART ITEM — singolo corso nel drawer del carrello
// ============================================================

import React from 'react';
import { CartItem as CartItemType } from '../../../../types/cart';
import { useCart } from '../../../../contexts/CartContext';
import './CartItem.css';

interface CartItemProps {
  item: CartItemType;
}

const CartItem: React.FC<CartItemProps> = ({ item }) => {
  const { removeItem } = useCart();
  const { course } = item;

  return (
    <div className="cart-item">
      {/* Immagine / placeholder */}
      <div className="cart-item-image">
        {course.imageUrl ? (
          <img src={course.imageUrl} alt={course.title} />
        ) : (
          <div className="cart-item-image-placeholder">
            <i className="bi bi-play-circle" />
          </div>
        )}
      </div>

      {/* Info corso */}
      <div className="cart-item-info">
        <p className="cart-item-title">{course.title}</p>
        {course.subtitle && (
          <p className="cart-item-subtitle">{course.subtitle}</p>
        )}
        <div className="cart-item-prices">
          <span className="cart-item-price">€ {course.price}</span>
          {course.originalPrice && (
            <span className="cart-item-original-price">
              € {course.originalPrice}
            </span>
          )}
        </div>
      </div>

      {/* Rimuovi */}
      <button
        className="cart-item-remove"
        onClick={() => removeItem(course.id)}
        aria-label={`Rimuovi ${course.title} dal carrello`}
      >
        <i className="bi bi-x-lg" />
      </button>
    </div>
  );
};

export default CartItem;
